import { render, staticRenderFns } from "./QLPStats.vue?vue&type=template&id=6f4102b4&scoped=true"
import script from "./QLPStats.vue?vue&type=script&lang=js"
export * from "./QLPStats.vue?vue&type=script&lang=js"
import style0 from "./QLPStats.vue?vue&type=style&index=0&id=6f4102b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4102b4",
  null
  
)

export default component.exports